export const environment = {
    production: false,
    // apiMiddlewareUrlForSuperAdmin: 'https://localhost:4201/',
    // apiMiddlewareUrl: 'https://localhost:4201',
    apiMiddlewareUrlForSuperAdmin: 'https://db-test.shiningonsafety.com:4201/',
    apiMiddlewareUrl: 'https://db-test.shiningonsafety.com:4201/',
    recaptcha: {
        siteKey: '6Lfir7kpAAAAAHoNUZOI5NGi0O5fXX6c6NKhKGkv',
    },
    // squareApplicationId: 'sandbox-sq0idb-w3xANs220G92AYDp7KzXeg', //Test
    // squareLocationId: 'L8DQRDQ2E8GXY', //Test

    squareApplicationId: 'sq0idp-aycFbB-u9AtjKyT8DPOScg', //LIVE
    squareLocationId: 'L680NKX2KGZT5', //LIVE
};
``